function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.5 24c0 12.426-10.074 22.5-22.5 22.5S1.5 36.426 1.5 24 11.574 1.5 24 1.5 46.5 11.574 46.5 24z",
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.6 15.601l8.4 8.4m8.485 8.4L24 24.001m-8.4 8.4l8.4-8.4m8.485-8.485L24 24",
  stroke: "currentColor",
  strokeWidth: 2
});

const SvgCrossCircle = props => React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  fill: "none"
}, props), _ref, _ref2);

export default SvgCrossCircle;